import HourInput, { HourInputProps } from '@repo/ui/hour-input'

import { useFormField } from '../forms/form'

const ControlledHourInput: React.FC<HourInputProps> = (props) => {
  const { error } = useFormField()

  return (
    <HourInput
      {...props}
      label={props.label ?? "Sélectionner l'heure"}
      errorMessage={error ? String(error?.message) : undefined}
    />
  )
}

export default ControlledHourInput
